module.exports = __webpack_public_path__ + "static/media/radiobutton_ON.6f6242ff.svg";